import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { graphviz, GraphvizOptions, Engine } from 'd3-graphviz';
// We would prefer to jsut use react-graphviz, but, it does not support adding images.
// We need to directly use d3-graphviz (instead of just react-graphviz) so we can add images.
// But... we get a crazy error about not being able to load the wasm for graphviz when we directly use d3-graphviz.
// But... if we also include react-graphviz (and render it), the bug goes away.
// The correct fix moving forward to to abandom graphviz and just use d3.. but we dont have the time right now.
import { Graphviz as FixWasmIssue } from 'graphviz-react';

export interface IGraphvizProps {
    dot: string;
    options?: GraphvizOptions;
    className?: string;
    images?: { src: string; w: string; h: string }[];
    engine?: Engine;
}

const defaultOptions: GraphvizOptions = {
    fit: true,
    height: 992,
    width: 992,
    zoom: false,
    useWorker: false,
};

let counter = 0;
const getId = () => `graphviz${counter++}`;

export const Graphviz = ({
    dot,
    className,
    options = {},
    images = [],
    engine = 'fdp',
}: IGraphvizProps) => {
    const id = useMemo(getId, []);

    useEffect(() => {
        let gv = graphviz(`#${id}`)
            .engine(engine)
            .options({
                ...defaultOptions,
                ...options,
            });
        images.forEach((img) => {
            gv = gv.addImage(img.src, img.w, img.h);
        });
        gv.renderDot(dot);
    }, [dot, options, images, engine]);
    return (
        <>
            <div className={className} id={id} />
            <FixWasmIssue dot={`graph {}`} />
        </>
    );
};
